import React, { useEffect } from "react";
import styles from "./styles.module.css";
import { Box, Drawer, IconButton } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import UseLocalStorageState from "../../../hooks/useLocalStorageState";
import ProfileImage from "./components/profileImage";
import UploadProfileImage from "./components/profileImage/upload-profile-image";
import EditProfileImage from "./components/profileImage/edit";
import DeleteProfileImage from "./components/profileImage/delete";
import ProfileTabs from "./components/profileTabs";
import DisplayTabs from "./components/profileTabs/displayTabs";
import ProfileName from "./components/profileName";
import UploadSkillImage from "../my-skills/components/skills-cover-image/upload-skill-image";
import EditSkillImage from "../my-skills/components/skills-cover-image/edit";
import DeleteSkillImage from "../my-skills/components/skills-cover-image/delete";
import Loading from "../../../components/loading/default";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../../../context/themeContext";
import { useSelector } from "react-redux";
import useProtectedAuth from "../../../hooks/useProtectedAuth";
import useManageProjects from "../../../hooks/useManageProjects";
import DrawerList from "./components/drawerList";
import { defaultProfileImageSquare } from "../../../constants";
import Invalid from "../../../components/common/popup";

function Profile() {
  useProtectedAuth();
  const { theme } = useTheme();
  const { pageLoading } = useSelector((state) => state.isLoading);
  const [profileBar, setProfileBar] = UseLocalStorageState("myprofile-bar", 0);
  const [sectionTab, setSectionTab] = UseLocalStorageState("section-tab", 0);
  const {
    data: { selectedProfileImage, isProfileImageDeleteOpen },
  } = useSelector((state) => state.profileImage);
  const {
    data: { selectedSkillImage, isSkillImageDeleteOpen },
  } = useSelector((state) => state.skillImage);

  const { toggleDrawer } = useManageProjects();
  const { isDrawerOpen } = useSelector((state) => state.manageProjects);
  const user = useSelector((state) => state.user.value);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const sectionNames = ["about", "skills", "projects", "shoutouts"];
  const projectsTabNames = ["hosted", "applications", "liked"];
  const shoutoutsTabNames = ["received", "given"];
  const [redirectUrl, setRedirectUrl] = UseLocalStorageState(
    "redirectUrl",
    `/profile/${sectionNames[profileBar]}`
  );

  const initializeNavigation = () => {
    const section = pathname.split("/")[2];
    setProfileBar(sectionNames.indexOf(section));
    if (section === "shoutouts") {
      const tab = pathname.split("/")[3];
      setSectionTab(shoutoutsTabNames.indexOf(tab));
    } else if (section === "projects") {
      const tab = pathname.split("/")[3];
      setSectionTab(projectsTabNames.indexOf(tab));
    }
  };

  useEffect(() => {
    if (pathname === "/profile") {
      let path;
      switch (profileBar) {
        case profileBar <= 1:
          path = `/profile/${sectionNames[profileBar]}`;
          break;
        case 2:
          path = `/profile/${sectionNames[profileBar]}/${projectsTabNames[sectionTab]}`;
          break;
        case 3:
          path = `/profile/${sectionNames[profileBar]}/${shoutoutsTabNames[sectionTab]}`;
          break;
        default:
          path = `/profile/about`;
          break;
      }

      setRedirectUrl(path);
      navigate(path);
    } else {
      initializeNavigation();
    }
  }, []);

  useEffect(() => {
    setRedirectUrl(pathname);
    initializeNavigation();
  }, [pathname]);

  const data = {
    profileBar,
    setProfileBar,
  };

  const handleShutClick = () => {
    setProfileBar(3);
    navigate("/profile/shoutouts/received");
  };

  if (pageLoading) {
    return <Loading />;
  }

  if (!user) {
    return <Loading />;
  }

  return (
    <Box className={styles.parent}>
      <Box
        className={styles.cardDetails}
        sx={{
          bgcolor: theme.palette.lightgrey.lightgrey600,
        }}
      >
        <Invalid />
        {selectedProfileImage &&
          !selectedProfileImage.includes(defaultProfileImageSquare) && (
            <EditProfileImage />
          )}
        {isProfileImageDeleteOpen && <DeleteProfileImage />}
        {selectedSkillImage && <EditSkillImage />}
        {isSkillImageDeleteOpen && <DeleteSkillImage />}
        <Box className={styles.myCardDetails}>
          <Box className={styles.userDetails}>
            <Box className={styles.details}>
              <ProfileImage />
              <ProfileName />
            </Box>
          </Box>
          <Box className={styles.tabs}>
            <ProfileTabs data={data} />
            <IconButton onClick={toggleDrawer(true)}>
              <MoreHoriz sx={{ color: "#FFF" }} />
            </IconButton>
            <Drawer
              anchor="bottom"
              open={isDrawerOpen}
              onClose={toggleDrawer(false)}
              sx={{
                "& .MuiPaper-root": {
                  maxWidth: {
                    xs: "100%",
                  },
                  md: {
                    maxWidth: "400px !important",
                    left: "50% !important",
                    transform: "translateX(-50%) !important",
                  },
                },
              }}
            >
              <DrawerList
                toggleDrawer={toggleDrawer}
                handleShutClick={handleShutClick}
              />
            </Drawer>
          </Box>
        </Box>
        <DisplayTabs value={profileBar} />
      </Box>
      <UploadProfileImage />
      <UploadSkillImage />
    </Box>
  );
}

export default Profile;
